// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import axios from '../../axiosInstance';

// const API_URL = '/api/v1/plans';

// // ============== PUBLIC/USER ROUTES (No Auth Required) ==============

// /**
//  * Fetch active plans for regular users
//  * @param {boolean} includeExpired - Whether to include expired plans
//  */
// export const fetchPlans = createAsyncThunk(
//   'plans/fetchPlans',
//   async (includeExpired = false, { rejectWithValue }) => {
//     try {
//       const response = await axios.get(`${API_URL}?includeExpired=${includeExpired}`);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

// /**
//  * Fetch plans with expiry info for users
//  */
// export const fetchPlansWithExpiry = createAsyncThunk(
//   'plans/fetchPlansWithExpiry',
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await axios.get(`${API_URL}/with-expiry`);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

// /**
//  * Fetch single plan by ID (public)
//  */
// export const fetchPlanById = createAsyncThunk(
//   'plans/fetchPlanById',
//   async (id, { rejectWithValue }) => {
//     try {
//       const response = await axios.get(`${API_URL}/${id}`);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

// // ============== SUPER ADMIN ROUTES (Auth + Admin Required) ==============

// /**
//  * SUPER ADMIN: Fetch ALL plans including inactive ones
//  * @param {Object} params - { includeExpired, includeInactive }
//  */
// export const superAdminFetchAllPlans = createAsyncThunk(
//   'plans/superAdminFetchAllPlans',
//   async ({ includeExpired = true, includeInactive = true } = {}, { rejectWithValue }) => {
//     try {
//       const response = await axios.get(
//         `${API_URL}/admin/all?includeExpired=${includeExpired}&includeInactive=${includeInactive}`
//       );
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

// /**
//  * SUPER ADMIN: Create new plan
//  */
// export const createPlan = createAsyncThunk(
//   'plans/createPlan',
//   async (planData, { rejectWithValue }) => {
//     try {
//       const response = await axios.post(API_URL, planData);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

// /**
//  * SUPER ADMIN: Update plan
//  */
// export const updatePlan = createAsyncThunk(
//   'plans/updatePlan',
//   async ({ id, planData }, { rejectWithValue }) => {
//     try {
//       const response = await axios.put(`${API_URL}/${id}`, planData);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

// /**
//  * SUPER ADMIN: Delete plan (soft delete)
//  */
// export const deletePlan = createAsyncThunk(
//   'plans/deletePlan',
//   async (id, { rejectWithValue }) => {
//     try {
//       const response = await axios.delete(`${API_URL}/${id}`);
//       return { id, ...response.data };
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

// /**
//  * SUPER ADMIN: Calculate plan price
//  */
// export const calculatePrice = createAsyncThunk(
//   'plans/calculatePrice',
//   async (calculationData, { rejectWithValue }) => {
//     try {
//       const response = await axios.post(`${API_URL}/calculate`, calculationData);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

// /**
//  * SUPER ADMIN: Renew expired plan
//  */
// export const renewPlan = createAsyncThunk(
//   'plans/renewPlan',
//   async ({ id, validityDays }, { rejectWithValue }) => {
//     try {
//       const response = await axios.post(`${API_URL}/${id}/renew`, { validityDays });
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

// const initialState = {
//   // User-facing data (only active plans)
//   userPlans: [],
//   userPlansWithExpiry: [],
  
//   // Admin-facing data (all plans including inactive)
//   adminPlans: [],
//   adminPlansWithExpiry: [],
  
//   // Common data
//   currentPlan: null,
//   calculatedPrice: null,
  
//   // UI states
//   loading: false,
//   error: null,
//   success: false,
// };

// const planSlice = createSlice({
//   name: 'plans',
//   initialState,
//   reducers: {
//     clearError: (state) => {
//       state.error = null;
//     },
//     clearSuccess: (state) => {
//       state.success = false;
//     },
//     clearCurrentPlan: (state) => {
//       state.currentPlan = null;
//     },
//     clearCalculatedPrice: (state) => {
//       state.calculatedPrice = null;
//     },
//     resetState: () => initialState,
//   },
//   extraReducers: (builder) => {
//     builder
//       // ========== USER ROUTES ==========
      
//       // Fetch Plans (User)
//       .addCase(fetchPlans.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchPlans.fulfilled, (state, action) => {
//         state.loading = false;
//         state.userPlans = action.payload.data || [];
//       })
//       .addCase(fetchPlans.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload?.message || 'Failed to fetch plans';
//       })

//       // Fetch Plans with Expiry (User)
//       .addCase(fetchPlansWithExpiry.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchPlansWithExpiry.fulfilled, (state, action) => {
//         state.loading = false;
//         state.userPlansWithExpiry = action.payload.data || [];
//       })
//       .addCase(fetchPlansWithExpiry.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload?.message || 'Failed to fetch plans with expiry';
//       })

//       // Fetch Single Plan (Public)
//       .addCase(fetchPlanById.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchPlanById.fulfilled, (state, action) => {
//         state.loading = false;
//         state.currentPlan = action.payload.data;
//       })
//       .addCase(fetchPlanById.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload?.message || 'Failed to fetch plan';
//       })

//       // ========== SUPER ADMIN ROUTES ==========

//       // Super Admin: Fetch All Plans
//       .addCase(superAdminFetchAllPlans.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(superAdminFetchAllPlans.fulfilled, (state, action) => {
//         state.loading = false;
//         state.adminPlans = action.payload.data || [];
//       })
//       .addCase(superAdminFetchAllPlans.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload?.message || 'Failed to fetch all plans';
//       })

//       // Super Admin: Create Plan
//       .addCase(createPlan.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//         state.success = false;
//       })
//       .addCase(createPlan.fulfilled, (state, action) => {
//         state.loading = false;
//         // Add to admin plans
//         state.adminPlans.unshift(action.payload.data);
//         // Also add to user plans if active
//         if (action.payload.data.isActive) {
//           state.userPlans.unshift(action.payload.data);
//         }
//         state.success = true;
//       })
//       .addCase(createPlan.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload?.message || 'Failed to create plan';
//         state.success = false;
//       })

//       // Super Admin: Update Plan
//       .addCase(updatePlan.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//         state.success = false;
//       })
//       .addCase(updatePlan.fulfilled, (state, action) => {
//         state.loading = false;
//         const updatedPlan = action.payload.data;
        
//         // Update in admin plans
//         const adminIndex = state.adminPlans.findIndex(p => p._id === updatedPlan._id);
//         if (adminIndex !== -1) {
//           state.adminPlans[adminIndex] = updatedPlan;
//         }
        
//         // Update in user plans (only if active)
//         const userIndex = state.userPlans.findIndex(p => p._id === updatedPlan._id);
//         if (updatedPlan.isActive) {
//           if (userIndex !== -1) {
//             state.userPlans[userIndex] = updatedPlan;
//           } else {
//             state.userPlans.unshift(updatedPlan);
//           }
//         } else {
//           // If plan becomes inactive, remove from user plans
//           if (userIndex !== -1) {
//             state.userPlans.splice(userIndex, 1);
//           }
//         }
        
//         state.currentPlan = updatedPlan;
//         state.success = true;
//       })
//       .addCase(updatePlan.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload?.message || 'Failed to update plan';
//         state.success = false;
//       })

//       // Super Admin: Delete Plan
//       .addCase(deletePlan.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//         state.success = false;
//       })
//       .addCase(deletePlan.fulfilled, (state, action) => {
//         state.loading = false;
//         // Remove from both arrays
//         state.adminPlans = state.adminPlans.filter(p => p._id !== action.payload.id);
//         state.userPlans = state.userPlans.filter(p => p._id !== action.payload.id);
//         state.success = true;
//       })
//       .addCase(deletePlan.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload?.message || 'Failed to delete plan';
//         state.success = false;
//       })

//       // Super Admin: Calculate Price
//       .addCase(calculatePrice.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(calculatePrice.fulfilled, (state, action) => {
//         state.loading = false;
//         state.calculatedPrice = action.payload.data;
//       })
//       .addCase(calculatePrice.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload?.message || 'Failed to calculate price';
//       })

//       // Super Admin: Renew Plan
//       .addCase(renewPlan.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//         state.success = false;
//       })
//       .addCase(renewPlan.fulfilled, (state, action) => {
//         state.loading = false;
//         const renewedPlan = action.payload.data;
        
//         // Update in admin plans
//         const adminIndex = state.adminPlans.findIndex(p => p._id === renewedPlan._id);
//         if (adminIndex !== -1) {
//           state.adminPlans[adminIndex] = renewedPlan;
//         }
        
//         // Update in user plans if active
//         const userIndex = state.userPlans.findIndex(p => p._id === renewedPlan._id);
//         if (userIndex !== -1 && renewedPlan.isActive) {
//           state.userPlans[userIndex] = renewedPlan;
//         }
        
//         state.success = true;
//       })
//       .addCase(renewPlan.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload?.message || 'Failed to renew plan';
//         state.success = false;
//       });
//   },
// });

// export const { 
//   clearError, 
//   clearSuccess, 
//   clearCurrentPlan, 
//   clearCalculatedPrice,
//   resetState 
// } = planSlice.actions;

// export default planSlice.reducer;

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../axiosInstance';

const API_URL = '/api/v1/plans';

// ============== PUBLIC/USER ROUTES (No Auth Required) ==============

/**
 * GET ALL PLANS - Public route
 * Fetch active plans for regular users
 * @param {boolean} includeExpired - Whether to include expired plans
 */
export const fetchPlans = createAsyncThunk(
  'plans/fetchPlans',
  async (includeExpired = false, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}?includeExpired=${includeExpired}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

/**
 * GET SINGLE PLAN - Public route
 * Fetch single plan by ID
 */
export const fetchPlanById = createAsyncThunk(
  'plans/fetchPlanById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

/**
 * GET PLANS WITH EXPIRY - Public route
 * Fetch plans with expiry info for users
 */
export const fetchPlansWithExpiry = createAsyncThunk(
  'plans/fetchPlansWithExpiry',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/with-expiry`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// ============== SUPER ADMIN ROUTES (Auth + Admin Required) ==============

/**
 * SUPER ADMIN: GET ALL PLANS
 * Fetch ALL plans including inactive ones
 * @param {Object} params - { includeExpired, includeInactive }
 */
export const superAdminFetchAllPlans = createAsyncThunk(
  'plans/superAdminFetchAllPlans',
  async ({ includeExpired = true, includeInactive = true } = {}, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${API_URL}/admin/all?includeExpired=${includeExpired}&includeInactive=${includeInactive}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

/**
 * SUPER ADMIN: CREATE PLAN
 */
export const createPlan = createAsyncThunk(
  'plans/createPlan',
  async (planData, { rejectWithValue }) => {
    try {
      const response = await axios.post(API_URL, planData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

/**
 * SUPER ADMIN: UPDATE PLAN
 */
export const updatePlan = createAsyncThunk(
  'plans/updatePlan',
  async ({ id, planData }, { rejectWithValue }) => {
    try {
      const response = await axios.put(`${API_URL}/${id}`, planData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

/**
 * SUPER ADMIN: DELETE PLAN (soft delete)
 */
export const deletePlan = createAsyncThunk(
  'plans/deletePlan',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`${API_URL}/${id}`);
      return { id, ...response.data };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

/**
 * SUPER ADMIN: CALCULATE PRICE
 */
export const calculatePrice = createAsyncThunk(
  'plans/calculatePrice',
  async (calculationData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_URL}/calculate`, calculationData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

/**
 * SUPER ADMIN: RENEW PLAN
 */
export const renewPlan = createAsyncThunk(
  'plans/renewPlan',
  async ({ id, validityDays }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_URL}/${id}/renew`, { validityDays });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  // User-facing data (from public routes)
  userPlans: [],
  currentPlan: null,
  userPlansWithExpiry: [],
  
  // Admin-facing data (from protected routes)
  adminPlans: [],
  calculatedPrice: null,
  
  // UI states
  loading: false,
  error: null,
  success: false,
};

const planSlice = createSlice({
  name: 'plans',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSuccess: (state) => {
      state.success = false;
    },
    clearCurrentPlan: (state) => {
      state.currentPlan = null;
    },
    clearCalculatedPrice: (state) => {
      state.calculatedPrice = null;
    },
    resetState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      // ========== PUBLIC/USER ROUTES ==========
      
      // GET ALL PLANS (Public)
      .addCase(fetchPlans.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPlans.fulfilled, (state, action) => {
        state.loading = false;
        state.userPlans = action.payload.data || [];
      })
      .addCase(fetchPlans.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Failed to fetch plans';
      })

      // GET SINGLE PLAN BY ID (Public)
      .addCase(fetchPlanById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPlanById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentPlan = action.payload.data;
      })
      .addCase(fetchPlanById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Failed to fetch plan';
      })

      // GET PLANS WITH EXPIRY (Public)
      .addCase(fetchPlansWithExpiry.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPlansWithExpiry.fulfilled, (state, action) => {
        state.loading = false;
        state.userPlansWithExpiry = action.payload.data || [];
      })
      .addCase(fetchPlansWithExpiry.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Failed to fetch plans with expiry';
      })

      // ========== SUPER ADMIN ROUTES ==========

      // GET ALL PLANS (Super Admin)
      .addCase(superAdminFetchAllPlans.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(superAdminFetchAllPlans.fulfilled, (state, action) => {
        state.loading = false;
        state.adminPlans = action.payload.data || [];
      })
      .addCase(superAdminFetchAllPlans.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Failed to fetch all plans';
      })

      // CREATE PLAN (Super Admin)
      .addCase(createPlan.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(createPlan.fulfilled, (state, action) => {
        state.loading = false;
        state.adminPlans.unshift(action.payload.data);
        // If the new plan is active, also add to user plans
        if (action.payload.data.isActive) {
          state.userPlans.unshift(action.payload.data);
        }
        state.success = true;
      })
      .addCase(createPlan.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Failed to create plan';
        state.success = false;
      })

      // UPDATE PLAN (Super Admin)
      .addCase(updatePlan.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updatePlan.fulfilled, (state, action) => {
        state.loading = false;
        const updatedPlan = action.payload.data;
        
        // Update in admin plans
        const adminIndex = state.adminPlans.findIndex(p => p._id === updatedPlan._id);
        if (adminIndex !== -1) {
          state.adminPlans[adminIndex] = updatedPlan;
        }
        
        // Update in user plans (only if active)
        const userIndex = state.userPlans.findIndex(p => p._id === updatedPlan._id);
        if (updatedPlan.isActive) {
          if (userIndex !== -1) {
            state.userPlans[userIndex] = updatedPlan;
          } else {
            state.userPlans.unshift(updatedPlan);
          }
        } else {
          // If plan becomes inactive, remove from user plans
          if (userIndex !== -1) {
            state.userPlans.splice(userIndex, 1);
          }
        }
        
        // Update currentPlan if it's the one being viewed
        if (state.currentPlan?._id === updatedPlan._id) {
          state.currentPlan = updatedPlan;
        }
        
        state.success = true;
      })
      .addCase(updatePlan.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Failed to update plan';
        state.success = false;
      })

      // DELETE PLAN (Super Admin)
      .addCase(deletePlan.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(deletePlan.fulfilled, (state, action) => {
        state.loading = false;
        // Remove from admin plans
        state.adminPlans = state.adminPlans.filter(p => p._id !== action.payload.id);
        // Remove from user plans
        state.userPlans = state.userPlans.filter(p => p._id !== action.payload.id);
        // Clear currentPlan if it's the deleted one
        if (state.currentPlan?._id === action.payload.id) {
          state.currentPlan = null;
        }
        state.success = true;
      })
      .addCase(deletePlan.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Failed to delete plan';
        state.success = false;
      })

      // CALCULATE PRICE (Super Admin)
      .addCase(calculatePrice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(calculatePrice.fulfilled, (state, action) => {
        state.loading = false;
        state.calculatedPrice = action.payload.data;
      })
      .addCase(calculatePrice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Failed to calculate price';
      })

      // RENEW PLAN (Super Admin)
      .addCase(renewPlan.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(renewPlan.fulfilled, (state, action) => {
        state.loading = false;
        const renewedPlan = action.payload.data;
        
        // Update in admin plans
        const adminIndex = state.adminPlans.findIndex(p => p._id === renewedPlan._id);
        if (adminIndex !== -1) {
          state.adminPlans[adminIndex] = renewedPlan;
        }
        
        // Update in user plans if active
        const userIndex = state.userPlans.findIndex(p => p._id === renewedPlan._id);
        if (userIndex !== -1 && renewedPlan.isActive) {
          state.userPlans[userIndex] = renewedPlan;
        }
        
        // Update currentPlan if it's the one being viewed
        if (state.currentPlan?._id === renewedPlan._id) {
          state.currentPlan = renewedPlan;
        }
        
        state.success = true;
      })
      .addCase(renewPlan.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Failed to renew plan';
        state.success = false;
      });
  },
});

export const { 
  clearError, 
  clearSuccess, 
  clearCurrentPlan, 
  clearCalculatedPrice,
  resetState 
} = planSlice.actions;

export default planSlice.reducer;